import { render, staticRenderFns } from "./TooltipNotes.vue?vue&type=template&id=55e3ed01&scoped=true&"
import script from "./TooltipNotes.vue?vue&type=script&lang=js&"
export * from "./TooltipNotes.vue?vue&type=script&lang=js&"
import style0 from "./TooltipNotes.vue?vue&type=style&index=0&id=55e3ed01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e3ed01",
  null
  
)

export default component.exports